<template>
  <div>
    <!-- FILTER -->
    <v-row dense>
      <v-col class="col-6 col-md-3">
        <v-menu
          ref="menudate1"
          v-model="menudate1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              filled
              dense
              v-model="date_start_formated"
              label="Data inicial"
              hint="Data inicial do relatório"
              persistent-hint
              prepend-inner-icon="mdi-calendar"
              v-bind="attrs"
              @blur="date = parseDate(date_start_formated)"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date_start" no-title @input="menudate1 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col  class="col-6 col-md-3">
        <v-menu
          ref="menudate2"
          v-model="menudate2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              filled
              dense
              v-model="date_end_formated"
              label="Data final"
              hint="Data final do relatório"
              persistent-hint
              prepend-inner-icon="mdi-calendar"
              v-bind="attrs"
              @blur="date = parseDate(date_end_formated)"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date_end" no-title @input="menudate2 = false"></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <!-- ICONS -->
    <v-row wrap justify="center">
      <v-col class="col-6 col-sm-3 text-center">
        <div class="bgalpha br pa-2">
          <img src="/icons/icons8-solar-energy-96.png" height="48"><br/>
          Energia gerada
          <h2>{{ total_power.toFixed(2) }}</h2>
          <div>kWh</div>
        </div>
      </v-col>
      <v-col class="col-6 col-sm-3 text-center">
        <div class="bgalpha br pa-2">
          <img src="/icons/icons8-money-box-96.png" height="48"><br/>
          Economia em R$
          <h2>{{ total_economy.toFixed(2) | money }}</h2>
          <div>R$</div>
        </div>
      </v-col>
      <v-col class="col-6 col-sm-3 text-center">
        <div class="bgalpha br pa-2">
          <img src="/icons/icons8-co2-96.png" height="48"><br/>
          Redução de CO²
          <h2>{{ total_co2 }}</h2>
          <div>kg</div>
        </div>
      </v-col>
      <v-col class="col-6 col-sm-3 text-center" v-if="false">
        <div class="bgalpha br pa-2">
          <img src="/icons/icons8-mine-cart-96.png" height="48"><br/>
          Economia de carvão
          <h2>602</h2>
          <div>kg</div>
        </div>
      </v-col>
      <v-col class="col-6 col-sm-3 text-center">
        <div class="bgalpha br pa-2">
          <img src="/icons/icons8-tree-planting-96.png" height="48"><br/>
          Árvores plantadas
          <h2>{{ total_tree }}</h2>
          <div>unidades</div>
        </div>
      </v-col>
    </v-row>

    <!-- MONTHS -->
    <!--<v-card flat class="mb-2" v-for="year_month in months.reverse()" :key="`year_month${year_month}`">-->
    <v-card flat class="mb-2" v-for="year_month in months" :key="`year_month${year_month}`">

      <!-- MONTH -->
      <v-toolbar dark dense flat>
        {{ year_month }} {{ nameOfMonth(year_month) }}
        <v-spacer></v-spacer>
        {{ sumPowerOfMonth(year_month).toFixed(2) }} kWh
      </v-toolbar>
      
      <!-- CHART -->
      <div class="pa-2 bgalpha" style="overflow:auto;">
        <div class="caption">
          <strong>kWh</strong> <!-- Max kW {{ maxPowerOfMonth(year_month) }} -->
        </div>
        
        <!-- BARS -->
        <table style="width:100%;background:#fff;border-radius:10px;">
          <tr>
            <td v-for="day in daysOfMonth(year_month)" :key="`powerbar${year_month}${day}`" style="vertical-align: bottom;border-right:1px solid #ddd;text-align:center;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">

                  <div v-bind="attrs" v-on="on">
                    <span v-if="powerOfDay(`${year_month}-${day}`) > 0" style="background:rgba(0,0,0,0.1);font-size:0.7em!important;padding:1px;border-radius:4px;">
                      {{ parseInt(powerOfDay(`${year_month}-${day}`)) }}
                    </span>

                    <v-card tile flat color="success" width="10" max-width="100%" :height="(powerOfDay(`${year_month}-${day}`) / maxPowerOfMonth(year_month)) * 100" style="margin:0 auto;border-top-left-radius:4px!important;border-top-right-radius:4px!important;">
                    </v-card>
                  </div>
                </template>
                <span>{{ parseInt(powerOfDay(`${year_month}-${day}`)) }} kWh</span>
              </v-tooltip>
            </td>
          </tr>
          <tr>
            <td v-for="day in daysOfMonth(year_month)" :key="`powerday${year_month}${day}`" class="caption text-center">
              <div class="caption" v-if="powerOfDay(`${year_month}-${day}`) > 0" style="font-size:0.9em!important;border-top:1px solid #ddd;">
                {{ day }}
              </div>
            </td>
          </tr>
        </table>
        <!-- BARS END -->
      </div>
      
    </v-card>

  </div>
</template>

<script>
  export default {
    props: {
      project_id: {
        type: Number,
        default: 0
      },
      project_tax: {
        type: Number,
        default: 0
      },
      value: Object
    },
    mounted() {
      this.dataloggerReport();
    },
    data() {
      return {
        barHeight: 100,
        days: [],
        years: {},

        date_start: new Date().toISOString().substr(0, 8) + '01',
        date_end: new Date().toISOString().substr(0, 10),

        menudate1: false,
        menudate2: false,

        monthData: []
      }
    },
    watch: {
      date_start() {
        this.dataloggerReport();
      },
      date_end() {
        this.dataloggerReport();
      }
    },
    computed: {
      total_tree() {
        return parseInt(this.total_co2 * 0.137);
      },
      total_co2() {
        return parseInt(this.total_power * 0.0927);
      },
      total_economy() {
        console.log(this.project_tax);
        const tax = this.project_tax > 0 ? this.project_tax : 50;
        return ((this.total_power * tax) / 100);
      },
      total_power() {
        return this.days.reduce((sum,day) => sum + day.power, 0);
      },
      months() {
        return [...new Set(this.days.map(day => `${day.year}-${day.month}`))];
      },
      date_start_formated() {
        return this.formatDate(this.date_start);
      },
      date_end_formated() {
        return this.formatDate(this.date_end);
      }
    },
    methods: {
      nameOfMonth(year_month) {
        const ym = year_month.split('-');
        //const year = ym[0];
        const month = ym[1];

        const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

        return months[parseInt(month) - 1];
      },
      powerOfDay(date) {
        const days = this.days.filter(day => day.date == date);
        return days.reduce((sum,day) => sum + day.power, 0);
        //return day && day.power ? parseInt(day.power) : 0;
      },
      daysOfMonth(year_month) {
        const ym = year_month.split('-');
        const year = ym[0];
        const month = ym[1];

        const last_day = new Date(year, month, 0).getDate();

        const days = [];
        
        for (let d = 1; d <= last_day; d++) {
          const day = ("0" + d.toString() ).slice(-2);
          days.push(day);
        }

        return days;
      },
      sumPowerOfMonth(year_month) {
        const ym = year_month.split('-');
        const year = ym[0];
        const month = ym[1];


        const days = this.days.filter(day => day.year == year && day.month == month);
        console.log(days);
        return days.reduce((sum,day) => sum + day.power, 0);
      },
      maxPowerOfMonth(year_month) {
        const ym = year_month.split('-');
        const year = ym[0];
        const month = ym[1];

        return this.days
          .filter(day => day.year == year && day.month == month)
          .reduce((max,day) => max = day.power > max ? day.power : max, 0);
      },
      dataloggerReport() {
        const payload = {
          date_start: this.date_start,
          date_end: this.date_end,
          project_id: this.project_id,
        };

        this.$api
        .post('/admin/project/datalogger.report', payload)
        .then(response => {
          if (Array.isArray(response.data)) {
            this.days = response.data;
          }
        });
      },
      formatDate (date) {
        if (! date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (! date) return null

        const [month, day, year] = ("" + date).split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
    },
  }
</script>

<style>
</style>
